import styled from "@emotion/styled";
import Error from "../../../components/Error";
import { MOBILE_SCREEN } from "../../../components/theme";

export const InputWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  align-items: center;
`;

export const ErrorWrapper = styled(Error)`
  margin-top: 8px;
`;

// for the input field loader and success icons same style so that they are aligned
export const IconContainer = styled.div`
  position: absolute;
  right: -40px;
  top: 50%;
  transform: translateY(-50%);
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${MOBILE_SCREEN} {
    right: -20px;
    width: 16px;
    height: 16px;
  }
`;
